import axios from 'axios';
import { ResetDataI } from './components/ConfirmPassword';
import { SignUpDataI } from './components/Signup';

const redirectUrl = window.location.origin;

export const getGoogleEndpoint = () => {
  return axios.get(process.env.NX_SECURITY_BASE_URL + `/oauth/google/endpoint?redirect_url=${redirectUrl}`);
};

export const getFacebookEndpoint = () => {
  return axios.get(
    process.env.NX_SECURITY_BASE_URL + `/oauth/facebook/endpoint?state=facebook&redirect_url=${redirectUrl}`
  );
};

export const authorizeWithGoogle = (authorizationCode: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/oauth/google/authorize', {
    code: authorizationCode,
    redirect_url: redirectUrl,
  });
};

export const authorizeWithFacebook = (authorizationCode: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/oauth/facebook/authorize', {
    code: authorizationCode,
    redirect_url: redirectUrl,
  });
};

export const login = (username: string, password: string) => {
  console.log(process.env.NX_SECURITY_BASE_URL);
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/login', {
    username,
    password,
  });
};

export const signup = (signupData: SignUpDataI) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/register', signupData);
};

export const passwordReset = (email: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/request-password-reset', {
    email: email,
  });
};

export const confirmRegistration = (pin: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/confirm-registration', {
    pin: pin,
  });
};

export const resetPassword = (email: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/request-password-reset', {
    email: email,
  });
};

export const changePassword = (email: string, currentPassword: string) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/request-password-change', {
    email: email,
    currentPassword: currentPassword,
  });
};

export const confirmPasswordReset = (data: ResetDataI) => {
  return axios.post(process.env.NX_SECURITY_BASE_URL + '/auth/confirm-password-reset', {
    pin: data.pin,
    password: data.password,
    confirmPassword: data.confirmPassword,
  });
};
